import { createSlice } from "@reduxjs/toolkit"

const appUserSlice = createSlice({
  name: "appUser",
  initialState: {
    userDetails: {},
    user: [],
    emailList: [],
    loading: false,
    refetchData: false,
  },
  reducers: {
    getUserListByFilters(state, action) {
      return {
        ...state,
        loading: true,
        refetchData: false,
        user: [],
      }
    },
    getUserListByFiltersSuccess(state, { payload }) {
      return {
        ...state,
        loading: false,
        user: payload.data && payload.data.users ? payload.data.users : [],
        total:
          payload.data.total && payload.data.total.value
            ? payload.data.total.value
            : payload.data.total
            ? payload.data.total
            : 0,
        refetchData: false,
      }
    },
    upsertAppUser(state) {
      return {
        ...state,
        loading: true,
        refetchData: false,
      }
    },
    upsertAppUserSuccess(state) {
      return {
        ...state.userDetails,
        loading: false,
        refetchData: true,
      }
    },
    addUser(state) {
      return {
        ...state,
        loading: true,
        refetchData: false,
      }
    },
    addUserSuccess(state) {
      return {
        ...state.userDetails,
        loading: false,
        refetchData: true,
      }
    },
    getEmailsOfUsers(state, action) {
      return {
        ...state,
        loading: true,
        refetchData: false,
        emailList: [],
      }
    },
    getEmailsOfUsersSuccess(state, { payload }) {
      return {
        ...state,
        loading: false,
        refetchData: false,
        emailList: payload.data || [],
      }
    },
    deleteAppUser(state) {
      return {
        ...state,
        loading: true,
        refetchData: false,
      }
    },
    deleteAppUserSuccess(state) {
      return {
        ...state,
        loading: false,
        refetchData: true,
      }
    },
    resetState() {
      return {
        userDetails: {},
        user: [],
        loading: false,
        refetchData: false,
      }
    },
  },
})

export const {
  getUserListByFilters,
  getUserListByFiltersSuccess,
  upsertAppUser,
  addUser,
  addUserSuccess,
  upsertAppUserSuccess,
  deleteAppUser,
  deleteAppUserSuccess,
  getEmailsOfUsers,
  getEmailsOfUsersSuccess,
  resetState,
} = appUserSlice.actions

export default appUserSlice.reducer
